<template>
  <div>
     <div class="nav_father">
      <div class="nav ">
        <div class='logo'>
         <router-link to="/">
            <img src="../assets/logo.png" alt="">
         </router-link>
      </div>
        <ul>
          <li v-for="(item,index) in nav" :key="index"  >
            <router-link :to="item.path" active-class="active" >{{item.text}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
   name:'Nav',
  data() {
    return {
       value:0,
       nav:[
        {text:'首页',path:'/Enter'},
        {text:'我们的服务',path:'/Children'},
        {text:'创新',path:'/Notice'},
        {text:'新闻中心',path:'/School'},
        {text:'关于我们',path:'/Recruit'},
        {text:'加入我们',path:'/Caucus'},
        {text:'联系我们',path:'/Contact'}
        ]
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.active{
  color: rgb(247, 180, 31) !important;
}
.nav{
  width: 1200px;
  /* height: 4vw; */
  height: 55px;
  background-color: white;
  /* width: 100%; */
  border-radius: 50px;
  /* position:absolute; */
}
.nav_father{
  width: 1200px;
  margin: 30px auto;
  /* min-width: 800px; */
  /* position: absolute;
  left: 50%;
  top:40px;
  transform: translate(-50%); */
  z-index: 10;
}
.nav ul{
  width: 890px;
   /* min-width: 600px; */
   /* width: 48vw; */
   display: flex;
  justify-content: space-around;
  float: left;
  /* margin-left: 19%; */
  margin: 0px auto;
  /* position: absolute;
  left: 23%; */
 
} 
.nav ul li{
   
  list-style: none;
  font-weight: bolder;
  line-height: 55px;
  width: 105px;
}

.nav ul li a {
  
  text-decoration: none;
  color: rgb(81, 81, 81);
  /* font-size: 0.89vw; */
  font-size: 16px;
}
.nav ul li:hover{
  cursor: pointer;
}
 .logo{
   width:266px;
   /* height: 13.49vh; */
   /* max-width: 266px; */
   /* max-height: 82px; */
   /* height: 5.125rem; */
  object-fit: cover ;
  float: left;
  margin-top: -14px;
  /* position: absolute;
  top: 52%;
  transform:trans lateY(-56%) 156*/
  /* left: -1%; */
 
 }
 .logo img{
   width: 100%;
   height: 100%;
   object-fit:contain;
   text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue